import i18n from 'modules/core/lib/i18n'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import configurator from 'modules/app_store/lib/SubscriptionAddonConfigurator'
import { APPS } from 'modules/billing/lib/types'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

const tabs = (
  subscriptionAddon: SubscriptionAddon,
  navigation: Navigation<NavigationPaths>,
  canSeeAppStore: boolean
) => {
  const config = configurator.getSubscriptionAddonConfig(subscriptionAddon, navigation)
  const id = subscriptionAddon.attributes.id
  const tabs = []

  /**
   * Hack to show the setting tab in some integrations until we definetly
   * kill the app store
   */
  const appsThatIncludeSettingsTab = [APPS.linkedin_limited_listings]

  if (canSeeAppStore) {
    tabs.push({
      name: i18n.t('app_store_v2.common.tabs.general'),
      index: true,
      href: navigation.appStore.id.general.fullPath({ id }),
    })
  }

  if (!config.hasSettings || !subscriptionAddon.attributes.enabled) return tabs

  if (appsThatIncludeSettingsTab.includes(id)) {
    tabs.push({
      name: i18n.t('app_store_v2.common.tabs.settings'),
      index: false,
      href: navigation.appStore.id.settings.fullPath({ id }),
    })
  }

  return [...tabs]
}

export default tabs
